import { format } from 'date-fns';
import { Heading } from '@livechat/design-system-react-components';

import * as styles from './styles';

type Props = {
  organizationName?: string;
  createdAt?: string;
  hideOrganizationName?: boolean;
  children: React.ReactNode;
};

export const OrganizationDetails: React.FC<Props> = ({
  children,
  organizationName,
  createdAt,
  hideOrganizationName = false,
}) => {
  const date = hideOrganizationName ? '' : format(new Date(createdAt), 'MMM dd, yyyy');

  return (
    <div
      css={styles.container}
      data-testid={
        hideOrganizationName
          ? `organization-details-box-${date.replace(/\s+/g, '-')}`
          : `organization-details-box-${organizationName.replace(/\s+/g, '-')}`
      }
    >
      {!hideOrganizationName && (
        <div css={styles.topDetailsContainer}>
          {organizationName ? (
            <Heading size="2xs" bold uppercase>
              ORGANIZATION NAME: {organizationName}
            </Heading>
          ) : (
            <Heading size="2xs" bold uppercase>
              ORGANIZATION CREATED ON {date}
            </Heading>
          )}
          {organizationName && (
            <Heading size="2xs" bold uppercase>
              CREATED ON {date}
            </Heading>
          )}
        </div>
      )}
      <div css={styles.detailsContainer}>{children}</div>
    </div>
  );
};
